(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Instagram"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STORY_DURATION = 3000;

  document.querySelectorAll('.client-avatars-section').forEach(function (section) {
    var row = section.querySelector('.client-avatars-row');
    var rowPrev = section.querySelector('.client-avatars-arrow-prev');
    var rowNext = section.querySelector('.client-avatars-arrow-next');

    function updateRowArrows() {
      if (!row || !rowPrev || !rowNext) {
        return;
      }
      var maxScroll = row.scrollWidth - row.clientWidth;
      var hasOverflow = maxScroll > 2;
      rowPrev.classList.toggle('is-hidden', !hasOverflow || row.scrollLeft <= 2);
      rowNext.classList.toggle('is-hidden', !hasOverflow || row.scrollLeft >= maxScroll - 2);
    }

    if (row && rowPrev && rowNext) {
      rowPrev.addEventListener('click', function () {
        row.scrollBy({ left: -row.clientWidth * 0.8, behavior: 'smooth' });
      });

      rowNext.addEventListener('click', function () {
        row.scrollBy({ left: row.clientWidth * 0.8, behavior: 'smooth' });
      });

      row.addEventListener('scroll', updateRowArrows, { passive: true });
      window.addEventListener('resize', updateRowArrows);
      window.addEventListener('load', updateRowArrows);
      updateRowArrows();
    }

    var modal = section.querySelector('.client-story-modal');
    var modalImage = section.querySelector('.client-story-modal-image');
    var headerAvatar = section.querySelector('.client-story-header-avatar');
    var headerName = section.querySelector('.client-story-header-name');
    var closeButton = section.querySelector('.client-story-modal-close');
    var prevButton = section.querySelector('.client-story-prev');
    var nextButton = section.querySelector('.client-story-next');
    var progressContainer = section.querySelector('.client-story-progress');
    var items = Array.prototype.slice.call(section.querySelectorAll('.client-avatar-item.is-clickable'));

    var stories = items.map(function (item) {
      return {
        image: item.getAttribute('data-story-image'),
        avatar: item.getAttribute('data-story-avatar'),
        name: item.getAttribute('data-story-name')
      };
    });

    var currentIndex = 0;
    var timerId = null;
    var segments = [];

    function buildProgressBar() {
      progressContainer.innerHTML = '';
      segments = [];
      stories.forEach(function () {
        var segment = document.createElement('div');
        segment.className = 'client-story-progress-segment';
        var fill = document.createElement('span');
        fill.className = 'client-story-progress-segment-fill';
        segment.appendChild(fill);
        progressContainer.appendChild(segment);
        segments.push(fill);
      });
    }

    function updateProgressBar() {
      segments.forEach(function (fill, index) {
        fill.classList.remove('is-active', 'is-complete');
        fill.style.width = '';
        if (index < currentIndex) {
          fill.classList.add('is-complete');
        }
      });
    }

    function clearTimer() {
      if (timerId) {
        clearTimeout(timerId);
        timerId = null;
      }
    }

    function startTimer() {
      clearTimer();
      var fill = segments[currentIndex];
      if (fill) {
        fill.style.width = '0%';
        void fill.offsetWidth;
        fill.classList.add('is-active');
      }
      timerId = setTimeout(function () {
        goNext();
      }, STORY_DURATION);
    }

    function renderStory() {
      var story = stories[currentIndex];
      if (!story) {
        closeModal();
        return;
      }
      modalImage.src = story.image;
      headerName.textContent = story.name || '';
      if (story.avatar) {
        headerAvatar.src = story.avatar;
        headerAvatar.style.display = '';
      } else {
        headerAvatar.style.display = 'none';
      }
      updateProgressBar();
      startTimer();
    }

    function goNext() {
      if (currentIndex < stories.length - 1) {
        currentIndex = currentIndex + 1;
        renderStory();
      } else {
        closeModal();
      }
    }

    function goPrev() {
      if (currentIndex > 0) {
        currentIndex = currentIndex - 1;
        renderStory();
      }
    }

    function openModal(startIndex) {
      currentIndex = startIndex;
      buildProgressBar();
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      renderStory();
    }

    function closeModal() {
      clearTimer();
      modal.classList.remove('is-open');
      modalImage.src = '';
      document.body.style.overflow = '';
    }

    items.forEach(function (item, index) {
      item.addEventListener('click', function () {
        openModal(index);
      });
    });

    if (closeButton) {
      closeButton.addEventListener('click', closeModal);
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        clearTimer();
        goPrev();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        clearTimer();
        goNext();
      });
    }

    if (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target === modal) {
          closeModal();
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (!modal.classList.contains('is-open')) {
        return;
      }
      if (event.key === 'Escape') {
        closeModal();
      } else if (event.key === 'ArrowRight') {
        clearTimer();
        goNext();
      } else if (event.key === 'ArrowLeft') {
        clearTimer();
        goPrev();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ReviewClients"] && !Shopify.designMode) return;
  try {
    
(function () {
  var RESIZE_DELAY = 200;

  function setupSlider(section) {
    var viewport = section.querySelector('.review-slider-viewport');
    var track = section.querySelector('[data-review-slider-track]');

    if (!viewport || !track) {
      return;
    }

    track.querySelectorAll('[data-review-slider-clone]').forEach(function (clone) {
      clone.remove();
    });
    track.classList.remove('is-ready');

    var items = Array.prototype.slice.call(track.children);

    if (!items.length) {
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    var setWidth = track.getBoundingClientRect().width;

    if (!setWidth) {
      return;
    }

    var clonesNeeded = Math.ceil(viewport.clientWidth / setWidth);

    for (var i = 0; i < clonesNeeded; i++) {
      items.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-review-slider-clone', 'true');
        track.appendChild(clone);
      });
    }

    var speed = parseFloat(track.getAttribute('data-speed')) || 40;

    track.style.setProperty('--rs-distance', setWidth + 'px');
    track.style.setProperty('--rs-duration', (setWidth / speed) + 's');
    track.classList.add('is-ready');

    section.setAttribute('data-review-slider-width', String(Math.round(viewport.clientWidth)));
  }

  function setupAll() {
    document.querySelectorAll('[data-review-slider]').forEach(setupSlider);
  }

  var resizeTimer = null;

  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('[data-review-slider]').forEach(function (section) {
        var viewport = section.querySelector('.review-slider-viewport');
        var previousWidth = section.getAttribute('data-review-slider-width');

        if (viewport && String(Math.round(viewport.clientWidth)) !== previousWidth) {
          setupSlider(section);
        }
      });
    }, RESIZE_DELAY);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }

  window.addEventListener('resize', onResize);
  document.addEventListener('shopify:section:load', setupAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-photos-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  var RESIZE_DELAY = 200;

  function setupSlider(section) {
    var viewport = section.querySelector('.trust-photos-viewport');
    var track = section.querySelector('[data-trust-photos-track]');

    if (!viewport || !track) {
      return;
    }

    track.querySelectorAll('[data-trust-photos-clone]').forEach(function (clone) {
      clone.remove();
    });
    track.classList.remove('is-ready');

    var items = Array.prototype.slice.call(track.children);

    if (!items.length) {
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    var setWidth = track.getBoundingClientRect().width;

    if (!setWidth) {
      return;
    }

    var clonesNeeded = Math.ceil(viewport.clientWidth / setWidth);

    for (var i = 0; i < clonesNeeded; i++) {
      items.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-trust-photos-clone', 'true');
        track.appendChild(clone);
      });
    }

    var speed = parseFloat(track.getAttribute('data-speed')) || 40;

    track.style.setProperty('--tp-distance', setWidth + 'px');
    track.style.setProperty('--tp-duration', (setWidth / speed) + 's');
    track.classList.add('is-ready');

    section.setAttribute('data-trust-photos-width', String(Math.round(viewport.clientWidth)));
  }

  function setupAll() {
    document.querySelectorAll('[data-trust-photos]').forEach(setupSlider);
  }

  var resizeTimer = null;

  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('[data-trust-photos]').forEach(function (section) {
        var viewport = section.querySelector('.trust-photos-viewport');
        var previousWidth = section.getAttribute('data-trust-photos-width');

        if (viewport && String(Math.round(viewport.clientWidth)) !== previousWidth) {
          setupSlider(section);
        }
      });
    }, RESIZE_DELAY);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }

  window.addEventListener('resize', onResize);
  document.addEventListener('shopify:section:load', setupAll);
})();

  } catch(e) { console.error(e); }
})();
})();
